import { render, staticRenderFns } from "./sidebarMenuShrink.vue?vue&type=template&id=004e3ac2&scoped=true&"
import script from "./sidebarMenuShrink.vue?vue&type=script&lang=ts&"
export * from "./sidebarMenuShrink.vue?vue&type=script&lang=ts&"
import style0 from "./sidebarMenuShrink.vue?vue&type=style&index=0&id=004e3ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e3ac2",
  null
  
)

export default component.exports